import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import PresentationApp from './presentation/App';
import ShortenerHome from './shortener/Home';
import FlowList from './flow/FlowList';
import FlowBuilder from './flow/FlowBuilder';
import FlowViewer from './flow/FlowViewer';
import './presentation/App.css'; // CSS global ajustado

// Componente wrapper para proteção simples
function Protected({ children }) {
  const [code, setCode] = useState('');
  const [unlocked, setUnlocked] = useState(false);

  const handleChange = (e) => {
    const value = e.target.value;
    setCode(value);
    if (value === '1923') {
      setUnlocked(true);
    }
  };

  if (unlocked) {
    return children;
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5',
      textAlign: 'center',
      padding: '20px'
    }}>
      <h1>🚧 Ainda em construção 🚧</h1>
      <p>Estamos trabalhando nisso! Insira o código secreto para visualizar:</p>
      <input
        type="number"
        value={code}
        onChange={handleChange}
        placeholder="Código numérico"
        style={{
          padding: '10px',
          fontSize: '16px',
          textAlign: 'center',
          border: '1px solid #ccc',
          borderRadius: '4px',
          width: '200px'
        }}
      />
    </div>
  );
}

function HomePage() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5',
      gap: '20px'
    }}>
      <h1>Link2.do - Escolha uma Funcionalidade</h1>
      <Link to="/presentation" style={{
        padding: '10px 20px',
        background: '#3498db',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '4px'
      }}>
        Presentation (Canvas simples)
      </Link>
      <Link to="/flow" style={{
        padding: '10px 20px',
        background: '#3498db',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '4px'
      }}>
          Flow (Concorrente do Linktr.ee)
      </Link>
      <Link to="/shortener" style={{
        padding: '10px 20px',
        background: '#3498db',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '4px'
      }}>
        Shortener (Encurtador de URLs tipo bit.ly)
      </Link>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Home com botões - protegida */}
          <Route path="/" element={<Protected><HomePage /></Protected>} />
          {/* Rotas para Presentation - IMPORTANTE: a ordem importa */}
          <Route path="/presentation/*" element={<PresentationApp />} />
          {/* Rotas para Shortener */}
          <Route path="/shortener" element={<ShortenerHome />} />
          {/* Rotas para Flow - protegida */}
          <Route path="/flow" element={<Protected><FlowList /></Protected>} />
          <Route path="/flow/builder/:id" element={<FlowBuilder />} />
          {/*
            IMPORTANTE: Esta rota deve vir POR ÚLTIMO antes do fallback
            Ela captura qualquer URL customizada do Flow (ex: /capelania)
            Mas só se não for uma das rotas definidas acima
          */}
          <Route path="/:flowUrl" element={<FlowViewer />} />
          {/* Rota padrão (fallback) - removida pois conflita com FlowViewer */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;